const axios = require('axios');
const API_URI_CART_DELETE = '/cart/destroy/';
const API_URI_CART_UPDATE = '/cart/update/';
const API_URI_CHECK_COMBINATION = '/cart/check_combination';
const API_URI_CART_UPSELL = '/cart/upsell/';

export const CartAPI = {
    delete(id, callback) {
        let url = API_URI_CART_DELETE + id ;
        return axios.post(url)
            .then((response) => {
                callback(response);
            })
            .catch((error) => {
                console.log(error);
            })
    },
    update(content, callback) {
        let url = API_URI_CART_UPDATE ;
        return axios.post(url, content)
            .then((response) => {
                callback(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
    },
    check_combination(content, collback) {
        return axios.post(API_URI_CHECK_COMBINATION, content)
            .then((response) => {
                collback(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
    },
    upsell(id, callback) {
        let url = API_URI_CART_UPSELL + id ;
        return axios.post(url)
            .then((response) => {
                callback(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/front/cart/api/carts.js